module.exports = __webpack_public_path__ + "img/banner.9e3b3571.png";